import React from 'react';
import AsyncListProducts from './listproducts/async';
import AsyncAddOrEditProduct from './addoreditproduct/async';
import AsyncAddProductFromLibrary from './addproductfromlibrary/async';
import AsyncListFrame from './listframe/async';
import AsyncAddOrEditFrame from './addoreditframe/async';
import SingleColumnLayout from '../../components/layout/SingleColumnLayout';
import {Redirect} from 'react-router';
import {Trans} from 'react-i18next';
import AsyncListCategory from './listcategory/async';
import AsyncListTint from './listlens/async';
import AsyncEyewearImageSpec from './addoreditframe/eyewearimagespec/async';
import DefaultLayout2 from '../../components/layout/DefaultLayout2';
import DefaultLayout3 from '../../components/layout/DefaultLayout3';

const parent1 = {
  title: <Trans i18nKey="p.webmodule.title">Online Service</Trans>,
  path: '/web-module',
};

const parent2 = {
  title: <Trans i18nKey="p.e.listproducts.title">Eyewear Products</Trans>,
  path: '/eyewear/list-products',
};

const parent3 = {
  title: <Trans i18nKey="p.e.listframe.title">Frame Management</Trans>,
  path: '/eyewear/list-frame',
};

export default [
  <SingleColumnLayout
    exact
    key="a"
    path="/eyewear/list-products"
    component={AsyncListProducts}
    parents={[parent1]}
    title={<Trans i18nKey="p.e.listproducts.title">Eyewear Products</Trans>}
  />,
  <SingleColumnLayout
    exact
    key="b"
    path="/eyewear/add-product"
    component={AsyncAddOrEditProduct}
    title={
      <Trans i18nKey="p.e.addoreditproduct.add.product.title">
        Add Eyewear
      </Trans>
    }
    parents={[parent2]}
  />,
  <SingleColumnLayout
    exact
    key="j"
    path="/eyewear/add-product-from-library"
    component={AsyncAddProductFromLibrary}
    title={
      <Trans i18nKey="p.e.addproductfromlibrary.title">
        Add Eyewear from Library
      </Trans>
    }
    parents={[parent2]}
  />,
  <SingleColumnLayout
    exact
    key="c"
    path="/eyewear/edit-product"
    component={AsyncAddOrEditProduct}
    title={
      <Trans i18nKey="p.e.addoreditproduct.edit.product.title">
        Edit Eyewear
      </Trans>
    }
    parents={[parent2]}
  />,
  <SingleColumnLayout
    exact
    key="d"
    path="/eyewear/list-frame"
    component={AsyncListFrame}
    parents={[parent2]}
    title={<Trans i18nKey="p.e.listframe.title">Frame Management</Trans>}
  />,
  <SingleColumnLayout
    exact
    key="e"
    path="/eyewear/add-frame"
    component={AsyncAddOrEditFrame}
    title={
      <Trans i18nKey="p.e.addoreditproduct.add.frame.title">Add Frame</Trans>
    }
    parents={[parent3]}
  />,
  <SingleColumnLayout
    exact
    key="f"
    path="/eyewear/edit-frame"
    component={AsyncAddOrEditFrame}
    title={
      <Trans i18nKey="p.e.addoreditproduct.edit.frame.title">Edit Frame</Trans>
    }
    parents={[parent3]}
  />,
  <SingleColumnLayout
    exact
    key="g"
    path="/eyewear/list-category"
    component={AsyncListCategory}
    title={
      <Trans i18nKey="p.e.listcategory.title">Category Tag Management</Trans>
    }
    parents={[parent2]}
  />,
  <SingleColumnLayout
    exact
    key="h"
    path="/eyewear/list-lens"
    component={AsyncListTint}
    title={<Trans i18nKey="p.e.listlens.title">Lens Tint Management</Trans>}
    parents={[parent3]}
  />,
  <DefaultLayout2
    exact
    key="i"
    path="/eyewear/image-spec"
    component={AsyncEyewearImageSpec}
    title={<Trans i18nKey="p.e.eyewear.imagespec">Image Spec</Trans>}
    parents={[parent3]}
  />,
  <DefaultLayout3
    exact
    key="i"
    path="/eyewear/image-spec-shopify"
    component={AsyncEyewearImageSpec}
    title={<Trans i18nKey="p.e.eyewear.imagespec">Image Spec</Trans>}
    parents={[parent3]}
  />,
  <Redirect key="j" exact from="/eyewear" to="/eyewear/list-products" />,
];
